<app-landing-navbar></app-landing-navbar>

<main class="login-page">
  <section class="login-layout">
    <app-auth-hero-section></app-auth-hero-section>

    <div class="login-panel">
      <div class="login-card">
        <div class="login-brand">
          <div class="login-brand__mark">
            <svg
              width="55"
              height="55"
              viewBox="0 0 33 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="29.3672"
                height="29.3672"
                rx="14.6836"
                fill="#1697B4"
              />
              <path
                d="M14.2794 17.2134C14.2442 17.1832 14.2096 17.1535 14.1766 17.1255C14.0903 17.2673 13.9809 17.3937 13.8539 17.4998C14.1029 17.7412 14.463 18.0733 14.5763 18.1502L14.75 17.623C14.6439 17.5317 14.4537 17.3635 14.2794 17.2134ZM17.4862 19.1112C17.3531 18.2805 16.4213 18.0694 15.7682 18.5065L15.142 17.9617L14.976 18.4553C14.976 18.4553 14.9793 18.4592 14.9809 18.4608L14.9721 18.4927L14.9639 18.4971C15.1376 18.6445 15.3091 18.7962 15.4768 18.9501C15.4202 19.6637 14.6939 20.0458 14.2888 20.5527L14.236 20.5626C14.1244 20.4109 13.9583 20.1371 13.9776 19.9419L13.9045 19.6901C13.756 19.1783 13.485 18.2426 13.3041 17.7945C13.1529 17.8391 12.9864 17.8627 12.822 17.855C12.905 18.3998 13.7335 20.5857 13.6142 20.8803C13.5279 20.8331 11.7868 18.0722 11.5999 17.7566C11.6867 17.6829 11.8044 17.5961 11.8945 17.502C11.7835 17.4091 11.6856 17.3008 11.6048 17.1804C11.4993 17.2503 11.4173 17.3382 11.3206 17.4366C10.6708 16.2893 9.92418 15.1265 9.22983 14.0039C10.0231 14.4932 10.7752 15.055 11.5361 15.5905C11.6202 15.4388 11.7296 15.303 11.8582 15.1892C10.9044 14.5047 9.98795 13.7746 8.92911 13.1875C8.75373 13.3678 8.60749 13.4695 8.44531 13.6257C9.95222 16.3684 11.9572 19.3592 13.6323 22.0689C14.1277 22.9662 14.3366 22.3559 14.9353 21.523C15.324 20.9502 15.7297 20.3141 15.849 20.1459C16.5752 20.7187 17.6577 19.9936 17.4862 19.1112ZM16.6308 19.2871C16.2267 19.4537 15.9864 18.8077 16.4004 18.6697C16.7935 18.5257 17.0222 19.1392 16.6308 19.2871Z"
                fill="#E5F2F5"
              />
              <path
                d="M15.4072 15.6328C15.1263 16.4085 14.7431 17.6433 14.4787 18.4223C14.3786 18.7131 14.2065 19.2723 14.1087 19.5438C13.9294 20.0073 13.9234 20.1447 14.228 20.5625L14.2807 20.5527L14.3066 20.5032C14.3049 20.4251 14.8871 18.7417 14.9558 18.4971L14.9641 18.4927L14.9729 18.4608C14.9729 18.4608 14.9701 18.4575 14.9679 18.4553C15.2753 17.5916 15.6051 16.7136 15.8476 15.8225C15.6909 15.7796 15.543 15.7153 15.4072 15.6328ZM14.7937 17.6675H14.7942C14.7942 17.6675 14.7964 17.6708 14.7981 17.673C14.7964 17.6713 14.7948 17.6691 14.7937 17.6675Z"
                fill="#E5F2F5"
              />
              <path
                d="M14.075 19.6562C14.0679 19.6799 14.0624 19.7035 14.0547 19.7272C14.0613 19.7035 14.0679 19.6793 14.075 19.6562Z"
                fill="#E5F2F5"
              />
              <path
                d="M14.1254 19.5078C14.1155 19.5315 14.0864 19.6216 14.0781 19.6469C14.0919 19.5996 14.1067 19.5534 14.1254 19.5078Z"
                fill="#E5F2F5"
              />
              <path
                d="M14.4806 18.4297L14.2656 19.0812C14.3338 18.864 14.3998 18.6413 14.4806 18.4297Z"
                fill="#E5F2F5"
              />
              <path
                d="M19.3274 9.73238C18.7402 10.7989 18.053 11.7363 17.4263 12.7704C17.3021 12.6698 17.1641 12.5862 17.0156 12.5224C17.2509 12.0469 18.4071 10.2013 18.8474 9.5625C18.9942 9.64387 19.1559 9.70214 19.3274 9.73238Z"
                fill="#E5F2F5"
              />
              <path
                d="M21.1562 7.89844L21.1716 8.35199C21.1887 8.20301 21.1837 8.04467 21.1562 7.89844Z"
                fill="#E5F2F5"
              />
              <path
                d="M20.0462 14.4102C19.6806 15.0848 17.7025 18.2487 17.47 18.484C17.3474 18.4416 17.1462 18.2904 17.0312 18.2113C17.4738 17.4499 18.0362 16.6697 18.4859 15.8984L17.5519 15.3833C17.6717 15.2651 17.774 15.1299 17.8559 14.982C18.1544 15.1018 18.6135 15.3223 18.7724 15.4405C19.0038 15.0771 19.3458 14.4729 19.6426 14.1172C19.7603 14.2354 19.8961 14.3349 20.0462 14.4102Z"
                fill="#00637C"
              />
              <path
                d="M18.2844 9.03851C17.0975 9.81862 14.756 11.2381 13.6505 12.0754C13.2425 11.8874 11.773 10.607 11.4234 10.3568C11.8423 9.26666 10.6262 8.39803 9.76199 9.21168C9.20948 9.05775 8.34635 8.55197 7.72072 8.29688C7.75205 8.4739 7.74601 8.66852 7.70312 8.84169C8.28972 9.08579 8.96868 9.49316 9.51075 9.70702C9.47392 10.0187 9.48766 10.1947 9.6306 10.4745C9.40794 10.7329 9.24301 10.9429 9.0396 11.2145C8.85983 11.4234 8.86038 11.43 8.85213 11.7071L8.94449 11.8181C9.36451 11.6175 9.68722 11.1573 10.0814 10.916C10.2035 10.9671 10.2947 11.0045 10.4212 11.0435C10.7307 11.9495 11.0924 12.899 11.4542 13.7852C11.5872 14.1178 11.7565 14.7242 11.9687 15.0964L12.3943 14.8776C12.3068 14.5274 12.0188 13.9067 11.9039 13.6142C12.2981 13.4921 13.132 12.9028 13.424 12.6565C13.435 12.6664 13.4471 12.6779 13.4608 12.6895L13.949 12.3778C13.9374 12.3679 13.9259 12.358 13.9155 12.3481C15.523 11.458 17.0409 10.381 18.5824 9.37771C18.4675 9.27985 18.3669 9.1655 18.2844 9.03851ZM10.8571 9.66304C10.7626 9.97036 10.2865 9.94122 10.232 9.62291C10.149 9.08359 11.0094 9.14021 10.8571 9.66304ZM12.6054 12.6862C12.4163 12.811 11.8797 13.1255 11.7774 13.2761C10.4453 10.0528 10.6042 10.3442 13.1221 12.3915C13.0331 12.436 12.8291 12.551 12.6054 12.6862ZM13.8401 12.2695C13.855 12.2865 13.8687 12.3025 13.8803 12.3151C13.8687 12.3025 13.8544 12.2865 13.8401 12.2695Z"
                fill="#E5F2F5"
              />
              <path
                d="M9.03705 11.2182C8.85728 11.4272 8.85838 11.4332 8.84958 11.7108C8.72259 11.5723 7.68023 10.2006 7.23438 9.58544C7.36082 9.48374 7.46802 9.35949 7.55049 9.21875C8.04143 9.88341 8.51258 10.5794 9.03705 11.2182Z"
                fill="#E5F2F5"
              />
              <path
                d="M16.6088 15.8594C16.6005 16.198 16.5555 16.5576 16.5406 16.8913C16.5313 17.0985 16.5274 18.0227 16.3867 18.0991L15.9766 18.1453C16.0161 17.8341 16.0486 16.4053 16.1426 15.8759C16.296 15.8907 16.4587 15.8858 16.6088 15.8594Z"
                fill="#00637C"
              />
              <path
                d="M14.8013 17.6696C14.8013 17.6696 14.798 17.6657 14.7969 17.6641H14.7974C14.7974 17.6641 14.7997 17.6674 14.8013 17.6696Z"
                fill="#E5F2F5"
              />
              <path
                d="M15.3635 15.75L15.2266 16.1656C15.2722 16.0111 15.3184 15.8682 15.3635 15.75Z"
                fill="#E5F2F5"
              />
              <path
                d="M10.1026 13.3178C9.72653 12.8356 9.3142 12.3189 8.94531 11.8186C9.12069 11.7422 9.18611 11.6751 9.33235 11.5547C9.72103 12.1693 10.2862 12.7059 10.7139 13.2765C10.8046 13.398 10.6232 13.9846 10.1026 13.3178Z"
                fill="#E5F2F5"
              />
              <path
                d="M7.73969 11.4486C7.69131 11.4568 7.39059 11.5959 7.34716 11.5728C7.26689 11.5266 6.71658 10.4409 6.46094 9.88284C6.62422 9.87349 6.7798 9.83556 6.92219 9.77344C7.19487 10.2627 7.62314 11.1841 7.73969 11.4486Z"
                fill="#00637C"
              />
              <path
                d="M19.4055 13.8025C18.8881 14.0702 18.5407 14.1681 18.0629 14.3473C18.0844 14.1851 18.0805 14.012 18.0547 13.8514C18.4071 13.7052 18.8804 13.5265 19.2367 13.3984C19.2741 13.5425 19.3312 13.6783 19.4055 13.8025Z"
                fill="#00637C"
              />
              <path
                d="M15.0522 15.3429C14.8988 15.4633 14.5695 15.7481 14.332 15.8856C14.2831 15.7228 14.2072 15.5716 14.1094 15.4369C14.3023 15.3034 14.5877 15.1186 14.7922 14.9922C14.8642 15.1203 14.9516 15.2379 15.0522 15.3429Z"
                fill="#00637C"
              />
              <path
                d="M20.2898 10.3497C20.1771 10.4773 20.0293 10.568 19.8643 10.6108L19.8357 10.6823C19.7956 10.3761 19.7423 10.0572 19.7621 9.74881C19.9204 9.73287 20.0727 9.69274 20.214 9.63281C20.2761 9.84997 20.2767 10.1611 20.2898 10.3497Z"
                fill="#E5F2F5"
              />
              <path
                d="M11.5171 13.9746L10.7573 14.3974C10.649 14.305 10.5396 14.2132 10.4297 14.1225C10.6996 13.8916 11.0273 13.7201 11.3373 13.5469C11.4028 13.6816 11.4863 13.8256 11.5171 13.9746Z"
                fill="#00637C"
              />
              <path
                d="M17.4295 12.7695L17.4141 12.7827C17.4174 12.7772 17.4212 12.7711 17.4246 12.7656C17.4262 12.7667 17.4279 12.7678 17.4295 12.7695Z"
                fill="#E5F2F5"
              />
              <path
                d="M21.1562 7.89844L21.1716 8.35199C21.1887 8.20301 21.1837 8.04467 21.1562 7.89844Z"
                fill="#E5F2F5"
              />
              <path
                d="M12.1003 13.0078C11.9414 13.1172 11.8166 13.2156 11.7749 13.2766C11.7699 13.2607 11.7639 13.2437 11.7578 13.2261L12.1003 13.0078Z"
                fill="#E5F2F5"
              />
              <path
                d="M11.9062 13.6145C11.9788 13.6046 12.1212 13.5354 12.2922 13.4375L11.9282 13.6695C11.9194 13.6486 11.9123 13.6299 11.9062 13.6145Z"
                fill="#E5F2F5"
              />
              <path
                d="M13.1183 12.3953C13.0293 12.4399 12.8253 12.5548 12.6016 12.69L13.0953 12.375C13.1046 12.3827 13.1123 12.3893 13.1183 12.3953Z"
                fill="#E5F2F5"
              />
              <path
                d="M13.4243 12.6562C13.4353 12.6661 13.4474 12.6777 13.4611 12.6892L12.9531 13.013C13.1714 12.8619 13.355 12.7239 13.4243 12.6562Z"
                fill="#E5F2F5"
              />
              <path
                d="M13.8359 12.2734C13.8508 12.2905 13.8645 12.3064 13.8761 12.3191C13.8645 12.3064 13.8502 12.2905 13.8359 12.2734Z"
                fill="#E5F2F5"
              />
              <path
                d="M14.2777 11.6172C14.0132 11.7904 13.7284 11.9844 13.6465 12.0768C13.6328 12.0735 13.6157 12.0652 13.5938 12.0537L14.2777 11.6172Z"
                fill="#E5F2F5"
              />
              <path
                d="M14.4957 12.0312L13.9476 12.3814C13.9361 12.3716 13.9245 12.3617 13.9141 12.3518C14.1307 12.2693 14.3055 12.1566 14.4957 12.0312Z"
                fill="#E5F2F5"
              />
              <path
                d="M13.5074 13.0027L12.2266 13.8203L12.4756 14.2105L13.7565 13.3929L13.5074 13.0027Z"
                fill="#00637C"
              />
              <path
                d="M14.849 13.1056L13.6562 12.1641L13.3694 12.5274L14.5622 13.4689L14.849 13.1056Z"
                fill="#E5F2F5"
              />
              <path
                d="M23.8311 7.6191C23.3056 6.89561 22.1269 7.19248 21.9443 8.05011C21.6469 8.00008 21.4413 7.92752 21.1543 7.90498C21.1818 8.05121 21.1868 8.20954 21.1697 8.35853C21.4204 8.40856 21.9037 8.4179 21.9669 8.6708C21.6029 9.20187 20.6997 9.90557 20.2956 10.3514C20.1829 10.479 20.0345 10.5697 19.8701 10.6126C19.3544 11.2574 18.0515 12.1926 17.4297 12.7748C17.5501 12.8737 17.6578 12.9881 17.7491 13.1151C19.3049 11.7808 20.8283 10.5065 22.3154 9.11446C22.4127 9.14084 22.4078 9.16723 22.4699 9.23321C22.0856 9.88578 21.6469 10.8649 21.3682 11.5538C21.5177 11.617 21.6557 11.7022 21.7778 11.8061C21.8778 11.4663 22.9873 9.54492 22.7228 9.38549C22.8141 9.33766 22.7805 9.38604 22.8899 9.369C23.8344 9.53393 24.3957 8.32609 23.8311 7.6191ZM23.0884 8.23978C22.6656 8.38272 22.4551 7.71366 22.8822 7.58776C23.3023 7.45032 23.5106 8.11114 23.0884 8.23978Z"
                fill="#E5F2F5"
              />
              <path
                d="M22.4178 9.16406C22.4316 9.17946 22.447 9.1998 22.4728 9.22838C22.326 9.47578 22.1622 9.79134 22 10.1278L22.4178 9.16406Z"
                fill="#E5F2F5"
              />
              <path
                d="M22.7031 9.75886C22.7746 9.556 22.8384 9.50487 22.7185 9.38117C22.8098 9.33334 22.7762 9.38172 22.8856 9.36468L22.7031 9.75886Z"
                fill="#E5F2F5"
              />
              <path
                d="M14.0792 19.6562C14.0561 19.7371 14.0346 19.8195 14 19.8959L14.0792 19.6562Z"
                fill="#E5F2F5"
              />
              <path
                d="M14.2689 19.0781C14.2134 19.2557 14.1711 19.3937 14.1172 19.5388C14.1199 19.5278 14.2656 19.0891 14.2689 19.0781Z"
                fill="#E5F2F5"
              />
              <path
                d="M14.8013 17.6696C14.8013 17.6696 14.798 17.6657 14.7969 17.6641H14.7974C14.7974 17.6641 14.7997 17.6674 14.8013 17.6696Z"
                fill="#E5F2F5"
              />
              <path
                d="M20.8382 8.12611C20.8382 8.83003 20.2675 9.40066 19.5636 9.40066C18.8597 9.40066 18.2891 8.83003 18.2891 8.12611C18.2891 7.4222 18.8597 6.85156 19.5636 6.85156C20.2675 6.85156 20.8382 7.4222 20.8382 8.12611Z"
                fill="#00637C"
              />
              <path
                d="M17.7429 14.1175C17.7429 14.9073 17.1026 15.5476 16.3129 15.5476C15.5231 15.5476 14.8828 14.9073 14.8828 14.1175C14.8828 13.3277 15.5231 12.6875 16.3129 12.6875C17.1026 12.6875 17.7429 13.3277 17.7429 14.1175Z"
                fill="#00637C"
              />
              <path
                d="M21.9708 12.876C21.9708 13.5626 21.4142 14.1192 20.7276 14.1192C20.041 14.1192 19.4844 13.5626 19.4844 12.876C19.4844 12.1894 20.041 11.6328 20.7276 11.6328C21.4142 11.6328 21.9708 12.1894 21.9708 12.876Z"
                fill="#00637C"
              />
              <path
                d="M14.0801 16.2979C14.0801 16.9845 13.5235 17.5411 12.837 17.5411C12.1504 17.5411 11.5938 16.9845 11.5938 16.2979C11.5938 15.6113 12.1504 15.0547 12.837 15.0547C13.5235 15.0547 14.0801 15.6113 14.0801 16.2979Z"
                fill="#00637C"
              />
              <path
                d="M7.46896 8.53527C7.46896 9.13292 6.98446 9.61741 6.38684 9.61741C5.78918 9.61741 5.30469 9.13292 5.30469 8.53527C5.30469 7.93761 5.78918 7.45312 6.38684 7.45312C6.98446 7.45312 7.46896 7.93761 7.46896 8.53527Z"
                fill="#00637C"
              />
              <path
                d="M8.81813 12.5614C8.81813 13.0397 8.43036 13.4275 7.95205 13.4275C7.47371 13.4275 7.08594 13.0397 7.08594 12.5614C7.08594 12.0831 7.47371 11.6953 7.95205 11.6953C8.43036 11.6953 8.81813 12.0831 8.81813 12.5614Z"
                fill="#00637C"
              />
              <path
                d="M21.5622 12.5663C21.5622 12.7668 21.3996 12.9294 21.1991 12.9294C20.9985 12.9294 20.8359 12.7668 20.8359 12.5663C20.8359 12.3657 20.9985 12.2031 21.1991 12.2031C21.3996 12.2031 21.5622 12.3657 21.5622 12.5663Z"
                fill="#E5F2F5"
              />
              <path
                d="M20.2975 7.62532C20.2975 7.89301 20.0805 8.11001 19.8128 8.11001C19.5451 8.11001 19.3281 7.89301 19.3281 7.62532C19.3281 7.35763 19.5451 7.14062 19.8128 7.14062C20.0805 7.14062 20.2975 7.35763 20.2975 7.62532Z"
                fill="#E5F2F5"
              />
              <path
                d="M16.3288 13.7269C16.3288 13.9946 16.1117 14.2116 15.8441 14.2116C15.5764 14.2116 15.3594 13.9946 15.3594 13.7269C15.3594 13.4592 15.5764 13.2422 15.8441 13.2422C16.1117 13.2422 16.3288 13.4592 16.3288 13.7269Z"
                fill="#E5F2F5"
              />
              <path
                d="M12.7236 16.4048C12.7236 16.6413 12.5319 16.833 12.2954 16.833C12.0589 16.833 11.8672 16.6413 11.8672 16.4048C11.8672 16.1683 12.0589 15.9766 12.2954 15.9766C12.5319 15.9766 12.7236 16.1683 12.7236 16.4048Z"
                fill="#E5F2F5"
              />
              <path
                d="M6.73143 8.1079C6.73143 8.3444 6.53971 8.53612 6.30322 8.53612C6.06672 8.53612 5.875 8.3444 5.875 8.1079C5.875 7.87141 6.06672 7.67969 6.30322 7.67969C6.53971 7.67969 6.73143 7.87141 6.73143 8.1079Z"
                fill="#E5F2F5"
              />
              <path
                d="M8.38086 12.2725C8.38086 12.4488 8.23788 12.5918 8.06153 12.5918C7.88516 12.5918 7.74219 12.4488 7.74219 12.2725C7.74219 12.0961 7.88516 11.9531 8.06153 11.9531C8.23788 11.9531 8.38086 12.0961 8.38086 12.2725Z"
                fill="#E5F2F5"
              />
              <path
                d="M11.0082 9.53533C11.0082 9.78784 10.8035 9.99254 10.551 9.99254C10.2985 9.99254 10.0938 9.78784 10.0938 9.53533C10.0938 9.28282 10.2985 9.07812 10.551 9.07812C10.8035 9.07812 11.0082 9.28282 11.0082 9.53533Z"
                fill="#00637C"
              />
              <path
                d="M23.3441 7.89471C23.3441 8.14722 23.1394 8.35191 22.8869 8.35191C22.6344 8.35191 22.4297 8.14722 22.4297 7.89471C22.4297 7.6422 22.6344 7.4375 22.8869 7.4375C23.1394 7.4375 23.3441 7.6422 23.3441 7.89471Z"
                fill="#00637C"
              />
              <path
                d="M16.891 19.051C16.891 19.3035 16.6863 19.5082 16.4338 19.5082C16.1813 19.5082 15.9766 19.3035 15.9766 19.051C15.9766 18.7984 16.1813 18.5938 16.4338 18.5938C16.6863 18.5938 16.891 18.7984 16.891 19.051Z"
                fill="#00637C"
              />
            </svg>
          </div>
          <div class="login-brand__text">
            <span class="login-brand__title">VMS</span>
            <span class="login-brand__caption">Vendor Management System</span>
          </div>
        </div>

        <div class="login-copy">
          <h1>{{ pendingTOTPChallenge ? 'Verify Code' : 'Sign In' }}</h1>
          <p>
            {{ pendingTOTPChallenge ? 'Enter the code from your authenticator
            app to finish signing in.' : 'Anambra State Government — Vendor
            Management System' }}
          </p>
        </div>

        @if (!pendingTOTPChallenge) {
        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="submit()">
          <label class="login-field">
            <span class="login-field__label">Email</span>
            <span
              class="login-input"
              [class.login-input--invalid]="emailControl.invalid && (emailControl.touched || emailControl.dirty)"
            >
              <svg
                class="login-input__icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4 6h16v12H4z"
                ></path>
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m4 8 8 6 8-6"
                ></path>
              </svg>
              <input
                type="email"
                formControlName="email"
                placeholder="example@gmail.com"
                autocomplete="email"
                [attr.aria-invalid]="emailControl.invalid && (emailControl.touched || emailControl.dirty)"
                [disabled]="isSubmitting"
              />
            </span>
            @if (emailErrorMessage) {
            <span class="login-field__error">{{ emailErrorMessage }}</span>
            }
          </label>

          <label class="login-field">
            <span class="login-field__label">Password</span>
            <span
              class="login-input"
              [class.login-input--invalid]="passwordControl.invalid && (passwordControl.touched || passwordControl.dirty)"
            >
              <svg
                class="login-input__icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8 10V8a4 4 0 1 1 8 0v2"
                ></path>
                <rect x="4" y="10" width="16" height="10" rx="2"></rect>
              </svg>
              <input
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                placeholder="**************"
                autocomplete="current-password"
                [attr.aria-invalid]="passwordControl.invalid && (passwordControl.touched || passwordControl.dirty)"
                [disabled]="isSubmitting"
              />
              <button
                type="button"
                class="login-input__toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                [disabled]="isSubmitting"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z"
                  ></path>
                  <circle cx="12" cy="12" r="2.5"></circle>
                </svg>
              </button>
            </span>
            @if (passwordErrorMessage) {
            <span class="login-field__error">{{ passwordErrorMessage }}</span>
            }
          </label>

          <div class="login-meta">
            <label class="login-check">
              <input
                type="checkbox"
                formControlName="rememberMe"
                [disabled]="isSubmitting"
              />
              <span>Remember me</span>
            </label>

            <a routerLink="/forgot-password" class="login-link"
              >Forget Password?</a
            >
          </div>

          <button type="submit" class="login-submit" [disabled]="!canSubmit">
            {{ isSubmitting ? 'Signing In...' : 'Sign In' }}
          </button>
        </form>

        <p class="login-footer">
          Don’t have an account?
          <a routerLink="/register">Create Account</a>
        </p>
        } @else {
        <form
          class="login-form login-form--totp"
          [formGroup]="totpForm"
          (ngSubmit)="verifyTOTP()"
        >
          <div class="totp-verification-card">
            <div class="totp-verification-card__icon" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.9"
              >
                <path
                  d="M12 3 5 6v5c0 4.4 2.9 8.4 7 9.7 4.1-1.3 7-5.3 7-9.7V6l-7-3Z"
                ></path>
                <path d="M8.8 12.2h6.4"></path>
                <path d="M12 9v6.4"></path>
              </svg>
            </div>
            <div>
              <div class="totp-verification-card__title">Password verified</div>
              <div class="totp-verification-card__copy">
                We need one more check for {{ verifiedLoginEmail }}.
              </div>
            </div>
          </div>

          <label class="login-field">
            <span class="login-field__label">Authenticator code</span>
            <span
              class="login-input login-input--code"
              [class.login-input--invalid]="totpCodeControl.invalid && (totpCodeControl.touched || totpCodeControl.dirty)"
            >
              <svg
                class="login-input__icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <rect x="4" y="4" width="16" height="16" rx="3"></rect>
                <path d="M8 9h8"></path>
                <path d="M8 13h5"></path>
                <path d="M8 17h3"></path>
              </svg>
              <input
                type="text"
                formControlName="code"
                inputmode="numeric"
                autocomplete="one-time-code"
                maxlength="6"
                placeholder="000000"
                [attr.aria-invalid]="totpCodeControl.invalid && (totpCodeControl.touched || totpCodeControl.dirty)"
                [disabled]="isVerifyingTOTP"
                (input)="onTOTPCodeInput($event)"
              />
            </span>
            @if (totpCodeErrorMessage) {
            <span class="login-field__error">{{ totpCodeErrorMessage }}</span>
            }
          </label>

          @if (challengeExpiresAtText) {
          <div class="totp-expiry-note">
            This code challenge expires at {{ challengeExpiresAtText }}.
          </div>
          }

          <button
            type="submit"
            class="login-submit"
            [disabled]="!canVerifyTOTP"
          >
            {{ isVerifyingTOTP ? 'Verifying...' : 'Verify and Sign In' }}
          </button>

          <button
            type="button"
            class="login-secondary"
            [disabled]="isVerifyingTOTP"
            (click)="resetTOTPChallenge()"
          >
            Use another account
          </button>
        </form>
        }
      </div>
    </div>
  </section>
</main>
